import { createStore } from '@stencil/store';
import { docData } from 'rxfire/firestore';
import { doc } from 'firebase/firestore';
import { EMPTY, Subscription, catchError, skipWhile } from 'rxjs';

import { FirebaseService } from '../utils/firebase';

import { WidgetSettings } from '@artask/tambr-models/models/widget-settings.model';


interface WidgetSettingsState {
  businessId: string;
  spaceId: string;
  categoryId: string;
  locationId: string;
  demo: any;

  appCheckFailed: boolean;
  appCheckError: any;

  pageBodyOverflow: string;
  selectedView: 'grid' | 'card';

  businessSettingsLoading: boolean;
  businessSettingsLoaded: boolean;
  businessSettings: WidgetSettings;
  businessSettingsSubscription: Subscription;
 }

const { state, reset, onChange } = createStore<WidgetSettingsState>({
  businessId: null,
  spaceId: null,
  categoryId: null,
  locationId: null,
  demo: null,

  appCheckFailed: false,
  appCheckError: null,

  pageBodyOverflow: null,
  selectedView: null,

  businessSettingsLoading: false,
  businessSettingsLoaded: false,
  businessSettings: null,
  businessSettingsSubscription: null
});


function setBusinessSettingsListener() {
  state.businessSettingsLoading = true;

  state.businessSettingsSubscription = docData( 
    doc( FirebaseService.firestore, `businesses/${ state.businessId }/settings/widget` ) 
  ).pipe(
    skipWhile( () => state.appCheckFailed ),
    catchError( error => {
      console.error( 'Error fetching settings:', error );
      state.businessSettingsLoading = false;
      return EMPTY;
    })
  ).subscribe( (widgetSettingsDoc: WidgetSettings) => {
    console.log('Settings', widgetSettingsDoc);
    state.businessSettings = widgetSettingsDoc;

    if ( !state.selectedView ) {
      if ( window.innerWidth <= 768 ) {
        state.selectedView = widgetSettingsDoc?.widgetLayoutSettings?.defaultMobileLayout ?? 'card';
      } else {
        state.selectedView = widgetSettingsDoc?.widgetLayoutSettings?.defaultDesktopLayout ?? 'grid';
      }
    }

    state.businessSettingsLoaded = true;
    state.businessSettingsLoading = false;
  });
}


function stopBusinessSettingsListener() {
  if ( state.businessSettingsSubscription ) state.businessSettingsSubscription.unsubscribe();
  reset();
}


export { 
  state as settings, 
  setBusinessSettingsListener, 
  stopBusinessSettingsListener,
  onChange as onSettingChange
};